import { Box } from "@mui/material";
import type { FC } from "react";
import { usePinchZoom } from "web_myplann/Chat/Hooks/Attachments/usePinchZoom";

type Props = {
	src: string;
	alt: string;
};

export const ChatAttachmentZoomableImage: FC<Props> = ({ src, alt }) => {
	const { containerRef, imageRef, handlers, style } = usePinchZoom();

	return (
		<Box
			ref={containerRef}
			width="100%"
			height="100%"
			overflow="hidden"
			sx={{ touchAction: "none" }}
			{...handlers}
		>
			<Box
				ref={imageRef}
				component="img"
				src={src}
				alt={alt}
				draggable={false}
				display="block"
				width="100%"
				height="100%"
				style={style}
				sx={{
					objectFit: "contain",
					userSelect: "none",
					WebkitUserSelect: "none",
					WebkitTouchCallout: "none",
					willChange: "transform",
				}}
			/>
		</Box>
	);
};
